const SEARCH_RETURN_STATE_KEYS = {
  orders: "itruck:return-to-orders-list",
  transports: "itruck:return-to-transports-list",
};

const SEARCH_LIST_SNAPSHOT_KEYS = {
  orders: "itruck:orders-list-snapshot",
  transports: "itruck:transports-list-snapshot",
};

const getSessionStorage = () => {
  if (typeof window === "undefined") return null;
  return window.sessionStorage || null;
};

export const getSearchDetailState = (type, returnTo) => {
  if (!SEARCH_RETURN_STATE_KEYS[type]) return undefined;

  return {
    fromSearchList: type,
    returnTo,
  };
};

export const markSearchListReturn = (type) => {
  const key = SEARCH_RETURN_STATE_KEYS[type];
  const storage = getSessionStorage();
  if (!key || !storage) return;

  try {
    storage.setItem(key, "1");
  } catch (_) {}
};

export const consumeSearchListReturn = (type) => {
  const key = SEARCH_RETURN_STATE_KEYS[type];
  const storage = getSessionStorage();
  if (!key || !storage) return false;

  try {
    const shouldReturn = storage.getItem(key) === "1";
    if (shouldReturn) {
      storage.removeItem(key);
    }
    return shouldReturn;
  } catch (_) {
    return false;
  }
};

export const saveSearchListSnapshot = (type, items) => {
  const key = SEARCH_LIST_SNAPSHOT_KEYS[type];
  const storage = getSessionStorage();
  if (!key || !storage || !items) return;

  try {
    storage.setItem(key, JSON.stringify(items));
  } catch (_) {}
};

export const consumeSearchListSnapshot = (type) => {
  const key = SEARCH_LIST_SNAPSHOT_KEYS[type];
  const storage = getSessionStorage();
  if (!key || !storage) return null;

  try {
    const rawSnapshot = storage.getItem(key);
    if (!rawSnapshot) return null;
    storage.removeItem(key);
    return JSON.parse(rawSnapshot);
  } catch (_) {
    try {
      storage.removeItem(key);
    } catch (__) {}
    return null;
  }
};

export const clearSearchListReturn = (type) => {
  const returnKey = SEARCH_RETURN_STATE_KEYS[type];
  const snapshotKey = SEARCH_LIST_SNAPSHOT_KEYS[type];
  const storage = getSessionStorage();
  if (!storage) return;

  try {
    if (returnKey) storage.removeItem(returnKey);
    if (snapshotKey) storage.removeItem(snapshotKey);
  } catch (_) {}
};
